import ds from 'Shared/ds';

export default class ReturnsApi {

    static returns = data => ds.get(this.#const.RETURNS, data);

    static return = id => ds.get(this.#const.RETURN, id);
    static create = formData => ds.postFormData(this.#const.CREATE, formData);

    static createData = (orderId) => ds.get(this.#const.CREATE_DATA);

    static #const = {
        RETURNS: "/process/return/data",
        RETURN: "/activity/return/data",
        CREATE_DATA: "/customer/return/create",
        CREATE: "/customer/return/create"
    };

    static Events = {
        CREATE: "returns.order.create"
    };
}